import autographIcon from '../containers/LandingPage/Assets/autographs.png';
import appearancesIcon from '../containers/LandingPage/Assets/appearances.png';
import shoutoutIcon from '../containers/LandingPage/Assets/shoutout.png';
import { JOB_POST } from './constants';

export const getSignatureServices = intl => [
  {
    icon: autographIcon,
    isImage: true,
    key: 'autographs',
    title: intl.formatMessage({ id: 'ExploreServices.Autographs.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Autographs.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Autographs.linkName' }),
    link: 'LandingPage',
  },
  {
    icon: shoutoutIcon,
    isImage: true,
    key: 'shoutouts',
    title: intl.formatMessage({ id: 'ExploreServices.Shoutouts.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Shoutouts.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Shoutouts.linkName' }),
    link: 'LandingPage',
  },
  {
    icon: 'package',
    key: 'endorsements',
    title: intl.formatMessage({ id: 'ExploreServices.Endorsements.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Endorsements.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Endorsements.linkName' }),
    link: 'LandingPage',
  },
  {
    icon: appearancesIcon,
    title: intl.formatMessage({ id: 'ExploreServices.MeetAndGreets.title' }),
    isImage: true,
    key: 'appearances',
    description: intl.formatMessage({ id: 'ExploreServices.MeetAndGreets.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.MeetAndGreets.linkName' }),
    link: 'LandingPage',
  },
  {
    icon: 'money',
    key: 'appearances',
    title: intl.formatMessage({ id: 'ExploreServices.CustomRequest.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.CustomRequest.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.CustomRequest.linkName' }),
    link: 'LandingPage',
  },
];
export const getBrandListingsQueryParams = () => ({
  include: ['author', 'images'],
  'fields.listing': [
    'createdAt',
    'title',
    'description',
    'geolocation',
    'price',
    'deleted',
    'state',
    'publicData',
    'publicData.listingType',
    'publicData.transactionProcessAlias',
    'publicData.unitType',
    // These help rendering of 'purchase' listings,
    // when transitioning from search page to listing page
    'publicData.pickupEnabled',
    'publicData.shippingEnabled',
  ],
  'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
  'fields.image': ['variants.scaled-small', 'variants.scaled-medium'],
});
export const getListingCategory = (categorySuffix, authorType) => {
  if (categorySuffix === JOB_POST) {
    return `${authorType}SinglejobPost,${authorType}BulkJobPost`;
  }
  return `${authorType}${categorySuffix}`;
};

// Add this helper function at the top of your file or in a utils file
export const isContentExpired = expirationDateUnix => {
  if (!expirationDateUnix) return false; // No expiration date = not expired

  const expirationDate = new Date(expirationDateUnix * 1000); // Convert Unix seconds to milliseconds
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to start of today
  return expirationDate < today;
};

export const getDaysUntilExpiration = expirationDateUnix => {
  if (!expirationDateUnix) return null;

  const expirationDate = new Date(expirationDateUnix * 1000);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const timeDiff = expirationDate - today;
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

  return daysDiff > 0 ? daysDiff : null;
};
